// Mirrors the patterns the backend enforces before it writes a Gradle file or shell script.
// Catching them here saves a round trip, but the backend stays the authority.
const QUOTED_TEXT = /^[^"\\$\r\n]{1,100}$/;
const FILE_TOKEN = /^[A-Za-z0-9._-]{1,100}$/;

export const FLAVOR_RULES = {
  flavorName: (value) => /^[a-z][A-Za-z0-9_]{0,63}$/.test(value),
  applicationName: (value) => QUOTED_TEXT.test(value),
  packageName: (value) => /^[A-Za-z][A-Za-z0-9_]*(\.[A-Za-z][A-Za-z0-9_]*)+$/.test(value),
  versionCode: (value) => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 2100000000,
  versionName: (value) => /^[0-9A-Za-z][0-9A-Za-z._-]{0,31}$/.test(value),
  primary: (value) => /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(value),
  secondary: (value) => /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(value),
  serverKey: (value) => /^[0-9]{1,3}$/.test(value),
  keystoreName: (value) => FILE_TOKEN.test(value),
  keyAlias: (value) => FILE_TOKEN.test(value),
  password: (value) => QUOTED_TEXT.test(value),
};

/** Names of the fields in `flavor` that would be refused. */
export function invalidFlavorFields(flavor) {
  return Object.entries(FLAVOR_RULES)
    .filter(([field, isValid]) => !isValid(String(flavor[field] ?? '').trim() === '' ? '' : String(flavor[field])))
    .map(([field]) => field);
}
